import type { Node } from '@xyflow/react'
import type { AiAgentV2NodeData, NodeDataBase } from '../types'
import { isAiAgentV2Type } from './ai-agent-v29'

export const hasCallChannelAiAgentV2 = (nodes: Node<NodeDataBase<unknown>>[]): boolean =>
  nodes.some(
    (n) =>
      isAiAgentV2Type(n.type) && (n as Node<AiAgentV2NodeData>).data?.config?.channel === 'call',
  )

// TEMPORARY WORKAROUND (v3 edit-lock; remove when the task compiler is re-enabled):
// True if any ai_agent_v2 node carries a server-compiled `_meta` task graph (v3
// task runtime). Used to disable edit/publish — a v3 flow can't be safely edited
// while the compiler is off (an edit would ride a stale graph).
export const hasAiAgentV2WithMeta = (nodes: Node<NodeDataBase<unknown>>[]): boolean =>
  nodes.some((n) => isAiAgentV2Type(n.type) && !!n.data?._meta)
